import type { FareSelectorMessageAnimationTypes } from "~/components/acquisition/SubscriptionManagerDesktop/common/FareSelectorAnimation";
import type { OnlineFunnel } from "~/constants/Funnel";
import type { Money } from "~/generated/graphql";

export interface FareProps {
  fareType: SubscriptionManagerDesktopFares;
  currentFareSelected: string;
  isSelectionDisabled: boolean;
  animation: {
    type: FareSelectorMessageAnimationTypes;
    duration: number;
    delay?: number;
    display: boolean;
  };
}

export enum SubscriptionManagerDesktopFares {
  PLUS = "plus",
  BASIC = "basic",
  NONPRIME = "nonPrime",
  UNSELECTED = "unselected",
}

export interface TrackingFunctionsWithFareProps {
  trackEvent: (any) => void;
  trackingVariation: TrackingVariation;
  funnel?: OnlineFunnel;
  isErrorMessage?: boolean;
  isPrimeCurrentlySelected?: boolean;
}

export type TrackingVariation = "prime" | "no-prime";

export interface FareDiscountProps {
  isReversedPricesEnabled?: boolean;
  label?: string;
  wasPrimeSelectedInResults: boolean;
  perks: Money;
  showTotalPrice?: boolean;
  discountLabel?: string;
  benefitsRevampLayout?: BenefitsRevampLayoutTypes;
}

export interface TrackingFunctions {
  trackTermsLink: CallbackFunction;
  trackLoginLink: CallbackFunction;
  trackPrimeWidget: CallbackFunction;
  trackPrimeFareSelected: CallbackFunction;
  trackFullFareSelected: CallbackFunction;
  trackKnowMoreLink: CallbackFunction;
  trackContinueToPay: CallbackFunction;
}

export interface TrackingFunctionsTiers {
  trackTermsLink: CallbackFunction;
  trackLoginLink: CallbackFunction;
  trackPrimeWidget: CallbackFunction;
  trackPrimeFareSelected: CallbackFunction;
  trackFullFareSelected: CallbackFunction;
  trackKnowMoreLink: CallbackFunction;
  trackOnLoadWidget: CallbackFunction;
  trackOnClickTiersTab: EventFunction;
  trackOnFareSelected: EventFunction;
  trackOnContinue: EventFunction;
}

export type EventFunction = (e) => void;
export type CallbackFunction = () => void;

export const NO_OFFER_SELECTED_ID = "0";

export enum BenefitsRevampLayoutTypes {
  BOXED = "boxedBenefits",
  CONDENSED = "condensedBenefits",
}
